import { post, postJson, filePost } from '@/utils/request';

/******** 检测依据 Start ********/
// 列表
export const getBasisList = params => {
  return post(`/app/sample/getBasisList`, params);
};
// 详情
export const getBasis = params => {
  return post(`/app/sample/getBasis`, params);
};
// 新增/编辑
export const editBasis = params => {
  return postJson(`/app/sample/editBasis`, params);
};
// 删除
export const deleteBasis = params => {
  return post(`/app/sample/deleteBasis`, params);
};
/******** 检测依据 End ********/

/******** 检测项目 Start ********/
// 列表
export const getItemList = params => {
  return post(`/app/sample/getItemList`, params);
};
// 详情
export const getItem = params => {
  return post(`/app/sample/getItem`, params);
};
// 新增/编辑
export const editItem = params => {
  return postJson(`/app/sample/editItem`, params);
};
// 删除
export const deleteItem = params => {
  return post(`/app/sample/deleteItem`, params);
};
/******** 检测项目 End ********/

/******** 检测样品 Start ********/
// 列表
export const getSampleList = params => {
  return post(`/app/sample/getSampleList`, params);
};
// 详情
export const getSample = params => {
  return post(`/app/sample/getSample`, params);
};
// 新增/编辑
export const editSample = params => {
  return postJson(`/app/sample/editSample`, params);
};
// 删除
export const deleteSample = params => {
  return post(`/app/sample/deleteSample`, params);
};
// 获取报告模版
export const queryReportWordTemplate = params => {
  return post(`/app/qsoffice/queryReportWordTemplate`, params);
};
// 上传报告模版
export const uploadReportWordTemplate = params => {
  return filePost(`/app/qsoffice/uploadReportWordTemplate`, params);
};
/******** 检测样品 End ********/

/******** 数据字典 Start ********/
// 字典树形接口增加code参数，不传就是整个字典树/dict/treeData?code=341200
export const getDictData = params => {
  return post(`/dict/treeData`, params);
};
// 详情
export const getDict = id => {
  return post(`/dict/get/${id}`);
};
// 详情bycode
export const getDictByCode = params => {
  return post(`/app/getDictByCode`, params);
};
// 新增/编辑
export const saveDict = params => {
  return post('/dict/save', params);
};
// 删除
export const deleteDict = id => {
  return post(`/dict/delete/${id}`);
};
// 详情ByCod
export const getDictsByCode = params => {
  return post(`app/getDictsByCode`, params);
};
/******** 数据字典 End ********/

/******** 功能模块 Start ********/
// 列表数据
export const getFunctionData = params => {
  return post('/function/treeData', params);
};
// 详情
export const getFunction = id => {
  return post(`/function/get/${id}`);
};
// 新增/编辑
export const saveFunction = params => {
  return post('/function/save', params);
};
// 删除
export const deleteFunction = id => {
  return post(`/function/delete/${id}`);
};
/******** 功能模块 End ********/

// 查询省市区树形
export const getAreaTree = params => {
  return post('/app/getAreaTree', params);
};

// #region ******** 标签模版管理 ********
// 列表
export const getFormTemplateList = params => {
  return post(`app/getFormTemplateList`, params);
};
// 获取默认模板
export const getDefaultFormTemplate = params => {
  return post(`app/getDefaultFormTemplate`, params);
};
// 详情
export const getFormTemplate = params => {
  return post(`app/getFormTemplate`, params);
};
// 编辑
export const editFormTemplate = params => {
  return postJson(`app/editFormTemplate`, params);
};
// 删除
export const deleteFormTemplate = params => {
  return post(`app/deleteFormTemplate`, params);
};
// #endregion **** 标签模版管理 ********

// #region ******** 样品规格单价管理 ********
// 列表
export const getSamplePriceList = params => {
  return post(`/app/sample/getSamplePriceList`, params);
};
// 编辑
export const editSamplePrice = params => {
  return postJson(`/app/sample/editSamplePrice`, params);
};
// #endregion **** 样品规格单价管理 ********

// #region ******** 车辆管理 ********
// 列表
export const getCarList = params => {
  return post(`/app/flow/getCarList `, params);
};
// 编辑
export const editCar = params => {
  return postJson(`/app/flow/editCar`, params);
};
// 删除
export const deleteCar = params => {
  return post(`/app/flow/deleteCar`, params);
};
// #endregion **** 车辆管理 ********
